import React, { useCallback, useEffect } from "react";
import { calculateCorrectedPressure, getCheck } from "../../../lib/calculation";
import Check from "../Check/Check";
import inspection_css from "../../inspection.module.css";
export default function CorrectedPressureCalc({
  check,
  equipment,
  topLevel,
  tosubequipmentinspection,
  station,
  data,
  set_data,
  saveTextCommentAndPhoto,
  deleteComment,
  index,
  setCheckValue,
  type,
  addInterceptor,
  params,
}) {
  // $scope.accept = function () {
  //   $scope.check.value = $scope.result;
  // };

  const calculate = useCallback(
    (check_copy) => {
      const differentialPressure = check_copy.children[0].value;
      const observedGPM = check_copy.children[1].value;
      const ratedFlow = equipment.ratedFlow;
      const filterMfg = equipment.filterMfg;
      let result;

      if (observedGPM && differentialPressure) {
        var corrected = calculateCorrectedPressure(
          differentialPressure,
          observedGPM,
          ratedFlow,
          filterMfg
        );

        result =
          corrected === null ? "Actual > Rated Flowrate" : corrected.toFixed(2);

        if (result === "NaN") {
          result = "N/A";
        }

        check_copy.children[2].value = result;
        check_copy.value = check_copy.children.every(function (child) {
          return child.value;
        });
      }
    },
    [equipment.filterMfg, equipment.ratedFlow]
  );

  const coarce = useCallback(
    (value, data_copy) => {
      if (!value || !data_copy) return;
      const check_result = getCheck(data_copy, check.id, topLevel);
      if (check_result) {
        calculate(check_result);
      }
    },
    [calculate, check.id, topLevel]
  );

  useEffect(() => {
    if (!check.children[2].disabled) {
      setCheckValue(true, check.children[2].id, topLevel, "disabled");
    }
  }, [check.children, setCheckValue, topLevel]);

  useEffect(() => {
    addInterceptor("CorrectedPressureCalc_" + check.id, coarce);
  }, [addInterceptor, check.id, coarce]);

  return (
    <div>
      <h1>{check.title}</h1>
      <div className={inspection_css["text"]}>
        <div>
          {check.critical && (
            <small className="bg-danger">
              This value puts equipment out of service!
            </small>
          )}
        </div>
        <span>
          {" "}
          <Check
            check={check.children[0]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>{" "}
        <span>
          {" "}
          <Check
            check={check.children[1]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>
        <label className={inspection_css["text"]}>
          <span>Rated Flow</span>{" "}
          <input type="text" readOnly value={equipment.ratedFlow} />
        </label>{" "}
        <span>
          {" "}
          <Check
            check={check.children[2]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>
      </div>
    </div>
  );
}
